import FishingExperience from '@/components/fishing/FishingExperience'

export default function FishingPage() {
  return <FishingExperience />
}
